import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunks
export const fetchUserMeals = createAsyncThunk(
  'user/fetchMeals',
  async (_, { getState, rejectWithValue }) => {
    const { mealsStatus } = getState().user;
    if (mealsStatus === 'succeeded') {
      return getState().user.meals;
    }

    const getMeals = () => axios.get("https://api.dailyfit.ae/api/user/get-meals", { withCredentials: true });

    try {
      let response;
      try {
        response = await getMeals();
      } catch (initialError) {
        console.warn("Initial user meals fetch failed, attempting token refresh...", initialError);
        await axios.get("https://api.dailyfit.ae/api/user/get-token", { withCredentials: true });
        response = await getMeals();
      }
      return response.data.data.meals;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch meals");
    }
  }
);

export const fetchUserMealPlans = createAsyncThunk(
  'user/fetchMealPlans',
  async (_, { getState, rejectWithValue }) => {
    const { mealPlansStatus } = getState().user;
    if (mealPlansStatus === 'succeeded') {
      return getState().user.mealPlans;
    }

    const getPlans = () => axios.get("https://api.dailyfit.ae/api/user/get-meal-plans", { withCredentials: true });

    try {
      let response;
      try {
        response = await getPlans();
      } catch (initialError) {
        console.warn("Initial user meal plans fetch failed, attempting token refresh...", initialError);
        await axios.get("https://api.dailyfit.ae/api/user/get-token", { withCredentials: true });
        response = await getPlans();
      }
      return response.data.data.mealPlans;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch meal plans");
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    meals: [],
    mealsStatus: 'idle', // idle | loading | succeeded | failed
    mealsError: null,

    mealPlans: [],
    mealPlansStatus: 'idle', // idle | loading | succeeded | failed
    mealPlansError: null,
  },
  reducers: {
    invalidateUserCache: (state) => {
      state.mealsStatus = 'idle';
      state.mealPlansStatus = 'idle';
    }
  },
  extraReducers: (builder) => {
    builder
      // Meals
      .addCase(fetchUserMeals.pending, (state) => {
        state.mealsStatus = 'loading';
      })
      .addCase(fetchUserMeals.fulfilled, (state, action) => {
        state.mealsStatus = 'succeeded';
        state.meals = action.payload;
      })
      .addCase(fetchUserMeals.rejected, (state, action) => {
        state.mealsStatus = 'failed';
        state.mealsError = action.payload || action.error.message;
      })
      // Meal Plans
      .addCase(fetchUserMealPlans.pending, (state) => {
        state.mealPlansStatus = 'loading';
      })
      .addCase(fetchUserMealPlans.fulfilled, (state, action) => {
        state.mealPlansStatus = 'succeeded';
        state.mealPlans = action.payload;
      })
      .addCase(fetchUserMealPlans.rejected, (state, action) => {
        state.mealPlansStatus = 'failed';
        state.mealPlansError = action.payload || action.error.message;
      });
  }
});

export const { invalidateUserCache } = userSlice.actions;

export const selectUserMeals = (state) => state.user.meals;
export const selectUserMealsStatus = (state) => state.user.mealsStatus;
export const selectUserMealPlans = (state) => state.user.mealPlans;
export const selectUserMealPlansStatus = (state) => state.user.mealPlansStatus;

export default userSlice.reducer;
